import type {FC} from 'react';
import React from 'react';
import logoPath from "./PNSLogoIcon.svg";

interface PNSProps {
    [key: string]: any;
}

const PNSLogo: FC<PNSProps> = (props) => (
    <img
        alt="PNS Logo"
        src={logoPath}
        height={66}
        width={66}
        style={{
            margin: 1
        }}
        {...props}
    />
);

export default PNSLogo;